import createApi from './api';

export default class AlertsSettingsService {
  constructor() {
    this.api = createApi({
      baseUrl: 'admin/notifications',
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async getAlertsSettings() {
    return this.api.get('list');
  }

  async updateAlertsSettings(params) {
    return this.api.post('update', params);
  }
}
